import { render, staticRenderFns } from "./problemLog.vue?vue&type=template&id=0b86d322&"
import script from "./problemLog.vue?vue&type=script&lang=js&"
export * from "./problemLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports